export const routeRoles = [
  {
    path: /^\/$/, // Главная страница — доступна любому авторизованному пользователю
    roles: ['*'],
  },
  {
    path: /^\/profile/, // Профиль — доступен любому авторизованному пользователю
    roles: ['*'],
  },
  {
    path: /^\/(main_report|main_report_new|finance-kpi-reports)$/,
    roles: ['fin_reports'],
  },
  {
    path: /^\/main_report/, // Пути, начинающиеся с '/main_report'
    roles: ['marketer'],
  },
  {
    path: /^\/fin/, // Все пути, начинающиеся с '/fin'
    roles: ['admin_fin', 'fin_expenses_read', 'fin_expenses_write'],
  },
  {
    path: /^\/trader_deposit_rub/, // Все пути, начинающиеся с '/trader_deposit_rub'
    roles: ['trader_deposit_rub'],
    default_path: '/trader_deposit_rub',
  },
  {
    path: /^\/fg/, // Все пути, начинающиеся с '/fg'
    roles: ['admin_deposit_rub'],
  },
  {
    path: /^\/mercury_merchant_history_log/,
    roles: ['view_cards'],
  },
  {
    path: /^\/users/,
    roles: ['view_users'],
  },
  {
    path: /^\/txs/,
    roles: ['view_transactions'],
  },
  {
    path: /^\/cards_issue_orders/,
    roles: ['view_card_issue_requests'],
  },
  {
    path: /^\/cards_topup_orders/,
    roles: ['view_card_topup_requests'],
  },
  {
    path: /^\/providers_master_account_topup_orders/,
    roles: ['admin'],
  },
  {
    path: /^\/cards/,
    roles: ['view_cards'],
  },
  {
    path: /^\/esim/,
    roles: ['esim_view', 'esim_operator'],
  },
  {
    path: /^\/refunds/,
    roles: ['admin'],
  },
  {
    path: /^\/amoka-operations/,
    roles: ['admin'],
  },
  {
    path: /^\/communications\/(push-rules|newsletters)/,
    roles: ['communications_view', 'communications_manage'],
  },
  {
    path: /^\/communications\/target-collections/,
    roles: ['communications_view', 'communications_manage'],
  },
  {
    path: /^\/communications\/tma-utm-(analytics|taxonomy)/,
    roles: ['communications_view', 'communications_manage'],
  },
  {
    path: /^\/communications\/tma-modal-alert/,
    roles: ['communications_view', 'communications_manage', 'communications_alert_manage'],
  },
  {
    path: /^\/communications\/help/,
    roles: ['communications_view', 'communications_manage', 'communications_stats_view'],
  },
  {
    path: /^\/communications\/stats/,
    roles: ['communications_stats_view'],
  },
  // Админ имеет доступ ко всему
  {
    path: /.*/, // Любой путь (универсальная регулярка)
    roles: ['admin'],
  },
];
